import { useContent } from "@/context/ContentContext";

export const Manifiesto = () => {
  const { manifiesto: m } = useContent();

  return (
    <section className="sec bn-sec" id="manifiesto" data-testid="manifiesto">
      <div className="wrap">
        <p className="lb">{m?.label}</p>
        <h2 className="h h2" style={{ marginTop: 20, maxWidth: 1300 }}>
          {m?.title} <span className="ab">{m?.title_accent}</span>
        </h2>
        <div className="split" style={{ marginTop: "clamp(48px,6vw,96px)" }}>
          <div>
            {(m?.paragraphs || []).map((p, i) => (
              <p className="lead" key={i} style={{ marginTop: i ? 20 : 0 }}>{p}</p>
            ))}
          </div>
          <div className="split" style={{ gap: 32 }}>
            <div>
              <p className="lb" style={{ marginBottom: 14 }}>{m?.no_es_label}</p>
              <ul className="list no">
                {(m?.no_es || []).map((t, i) => <li key={i}>{t}</li>)}
              </ul>
            </div>
            <div>
              <p className="lb" style={{ marginBottom: 14 }}>{m?.es_label}</p>
              <ul className="list">
                <li style={{ fontSize: "clamp(28px,2.6vw,40px)", color: "var(--bl)" }}>{m?.es}</li>
              </ul>
              <div className="chips" style={{ marginTop: 22 }}>
                {(m?.trabajamos || []).map((t, i) => <span className="chip" key={i}>{t}</span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
